var messages = {
    en: {
        menu:{
            our_company: {
                title : "OUR COMPANY",
                submenu:{
                    about_us: "ABOUT US",
                    our_leadership: "OUR LEADERSHIP",
                    our_services: "OUR SERVICES",
                    out_logos: "OUR LOGOS",
                }
            },
            our_products: {
                title : "OUR PRODUCTS",
                submenu:{
                    dairy_product: "DAIRY PRODUCT",
                    han_and_salami: "HAM & SALAMI",
                    truffle_and_mushroom: "TRUFFLE & MUSHROOM",
                    oil_and_vinegar: "OIL & VINEGAR",
                    grain_product: "GRAIN PRODUCT",
                    nuts_snacks_and_rice: "NUTS, SNACKS & RICE",
                    sauce_and_seasoning: "SAUCE & SEASONING",
                    tomatoes_and_preserved_product: "TOMATOES & PRESERVED PRODUCT",
                    beverage: "BEVERAGE",
                    our_valued_partners: "OUR VALUED PARTNERS",
                }
            },
            our_affiliates: {
                title : "OUR AFFILIATES",
                submenu:{
                    primo_mart: "PRIMO MART",
                    // shenzhen_zhengran_food: "SHENZHEN ZHENGRAN FOOD",
                    // amare: "AMARE BISTRO & WINE",
                    my_foundation: "MY FOUNDATION",
                }
            },
            our_recipes: {
                title : "OUR RECIPES",
                submenu:{
                    lorence_kitchen: "LORENCE KITCHEN",
                    pm_kitchen: "PM KITCHEN",
                }
            },
            news: {
                title : "NEWS",
                submenu:{
                    lorence: "LORENCE",
                    amare: "AMARE BISTRO & WINE",
                    my_foundation: "MY FOUNDATION",
                }
            },
            contact_us: {
                title : "CONTACT US",
            },
        },
        homepage: {
            slogan: 'THE LEADING IMPORTER OF<br>ITALIAN GROCERIES IN HONG KONG',
            about_us_title: 'ABOUT US',
            about_us_content: "Founded in the late 1950's, Lorence & Co was one of the leading importers of Italian groceries in Hong Kong. <br><p>At present, Lorence carries over 70 Italian brands of groceries. Lorence has been the sole distributors of these brands in Hong Kong for more than 70 years.</br>",
            read_more: "READ MORE",
            slogan2: "LORENCE & CO HAS BEEN<br>THE SOLE DISTRIBUTOR OF 70 ITALIAN BRANDS<br>IN HONG KONG FOR ABOUT 70 YEARS",
            slogan3: "WE STRIVE TO PROVIDE YOU WITH<br>PREMIUM FOOD AND WINE",
        },
        company_page: {
            about_us_title: 'ABOUT US',
            about_us_content: `
                <p>
                Established more than 40 years ago, Lorence & Co. is a private company owned by a successfully lady, Madam May Mang. Now, Lorence is in the management of 2nd generation, who has the mission of continuing Madam Mang’s spirit and passion in food and grocery from Italy. </span>
                </p>
                <p>
                In Hong Kong, Lorence is known as one of the leading Italian food and grocery distributor. It has built up a trusted network with its suppliers to ensure quality and reliable source of products are sold to its customers. Lorence serves wide range of HORECA and retail customers such as airline, prestige hotels, private clubs, theme park, local restaurants, supermarket, catering and gourmet shops.</span>
                </p>
            `,
            leadership_title: "OUR LEADERSHIP",
            leader1_title: "OUR FOUNDER",
            leader1_name: "Madam Mang Mee Yee",
            leader2_title: "OUR CEO",
            leader2_name: "Mr. Steven Chan",
            our_services_title: 'OUR SERVICES',
            our_services_content: `          
                <p>
                    To date, Lorence is not only the leading importer of Italian groceries in Hong Kong. It has its <span style="color: #E1CB8B;">own logistics team</span>, <span style="color: #E1CB8B;">own packaging facilities</span>, 
                    <span style="color: #E1CB8B;">refrigerated warehouse</span>, as well as a <span style="color: #E1CB8B;">fleet of refrigerated delivery trucks</span>.
                </p>
                <p>
                    Most importantly, Lorence is holding a <span style="color: #E1CB8B;">good standing Food Factory License</span> duly certified by the Hong Kong SAR Government.
                </p>
                <p>
                    With the said Food Factory License, Lorence <span style="color: #E1CB8B;">provides packaging, slicing and food 
                    processing services</span> to their customers.
                </p>
            `,
            our_logos_title: 'OUR LOGOS',
        },
        products_page: {
            title: 'OUR PRODUCTS',
            partners: 'OUR VALUED PARTNERS',
            slogan1: "THE LEADING IMPORTER OF ITALIAN GROCERIES",
            slogan2: "WE STRIVE TO PROVIDE PREMIUM FOOD AND WINE",
            slogan3: "THE SOLE DISTRIBUTOR OF MORE THAN 70 ITALIAN BRANDS",
        },
        product_info_page: {
            title: `TYPES OF <br>{product_category}`,
            partners: 'OUR VALUED PARTNERS',
            back: 'BACK',
            next: 'NEXT'
        },
        affiliate:{
            telephone: `T {telephone}`,
            email: `{email}`,
            event_photos: `EVENT<br>PHOTOS`,
            recipes: `VIDEO<br>RECIPES`,
        },
        affiliate_gallery_page: {
            title: `EVENT PHOTOS`,
            about_affiliate: `ABOUT<br>{affiliate_name}`,
        },
        affiliate_recipe_page: {
            title: `VIDEOS`,
            about_affiliate: `ABOUT<br>{affiliate_name}`,
            next_video: `NEXT<br>VIDEO`,
            prev_video: `PREVIOUS<br>VIDEO`,
        },
        kitchen_page: {
            video_title: `VIDEOS`,
            recipe_title: `RECIPES`,
            next_video: `NEXT<br>VIDEO`,
            prev_video: `PREVIOUS<br>VIDEO`,
        },
        affiliate_news_page: {
            title: `NEWS OF {affiliate_name}`,
            read_more: "READ MORE",
            featured_on: "Featured on",
        },
        contact_page: {
            company_name: `LORENCE & COMPANY`,
            address_title: `ADDRESS`,
            tel_title: `TEL`,
            fax_title: `FAX`,
            email_title: `EMAIL`,
            contact_us: `CONTACT US`,
            form_name: `First Name`,
            form_email: `Email`,
            form_subject: `Subject`,
            form_message: `Leave us a message`,
            form_submit_button: `SUBMIT`,
            form_submit_message: `Thanks for submitting!`,
        },
        footer: {
            address: `Flat B, C & D1, 6th Floor, China Insurance Group Building, 141 Des Voeux Road Central, Central, Hong Kong`,
            tel: `TEL: (852) 2557 6123`,
            fax: `FAX: (852) 2557 5621`,
            email: `EMAIL: <a class="links" href="mailto:info@lorencegroup.com">info@lorencegroup.com</a>`,
            credit: `@ 2026 by Subsidiary Company of Lorence Holdings Limited`,
        }
    },
    zh_TW: {
        menu:{
            our_company: {
                title : "關於義生洋行",
                submenu:{
                    about_us: "關於我們",
                    our_leadership: "我們的管理層",
                    our_services: "我們的服務",
                    out_logos: "我們的商標",
                }
            },
            our_products: {
                title : "產品",
                submenu:{
                    dairy_product: "奶類製品",
                    han_and_salami: "火腿和腸",
                    truffle_and_mushroom: "松露及菌類",
                    oil_and_vinegar: "油類及醋類",
                    grain_product: "穀物類",
                    nuts_snacks_and_rice: "果仁，小食及米類",
                    sauce_and_seasoning: "醬料及調味料類",
                    tomatoes_and_preserved_product: "番茄類及醃製產品",
                    beverage: "飲料",
                    our_valued_partners: "我們的夥伴",
                }
            },
            our_affiliates: {
                title : "關聯公司",
                submenu:{
                    primo_mart: "優質市場",
                    // shenzhen_zhengran_food: "深圳市正然食品有限公司",
                    // amare: "AMARE BISTRO & WINE",
                    my_foundation: "樂恩慈善機構",
                }
            },
            our_recipes: {
                title : "食譜",
                submenu:{
                    lorence_kitchen: "LORENCE KITCHEN",
                    pm_kitchen: "PM KITCHEN",
                }
            },
            news: {
                title : "信息",
                submenu:{
                    lorence: "義生洋行",
                    amare: "AMARE BISTRO & WINE",
                    my_foundation: "樂恩慈善機構",
                }
            },
            contact_us: {
                title : "聯繫我們",
            },
        },
        homepage: {
            slogan: "香港意大利食品進口商的<br>市場領導者之一",
            about_us_title: '關於我們',
            about_us_content: "義生洋行自50年代末創立直今，是香港意大利食品進口商的市場領導者之一。義生洋行已經引入了超過70個意大利品牌，並在香港獨家經營了這些品牌超過70年。",
            read_more: "了解更多",
            slogan2: "義生洋行<br>引入了超過70個意大利品牌<br>並在香港獨家經營了這些品牌超過70年",
            slogan3: "竭盡所能為客戶提供優質食品及酒類",
        },
        company_page: {
            about_us_title: '關於我們',
            about_us_content: `
                <p>
                    義生洋行有限公司由孟美儀女士創立，䇄立香港逾40載。現時，公司管理層已由第二代接班，並秉承孟女士對意大利食品的熱忱。</span>
                </p>
                <p>
                近半世紀，義生洋行有限公司專注於意大利食品批發業務。貴為業界翹楚，義生洋行致力為客戶提供優質可靠的產品，從而與客戶已建立堅實的互信關係。同時，公司客戶群全面覆蓋餐飲及零售市場如航空公司、五星級酒店、高級會所、主題樂園、本地餐廳、超市和零售店等，為大家帶來優質地道的意大利美食體驗。</span>
                </p>
            `,
            leadership_title: "我們的管理層",
            leader1_title: "義生洋行的創辦人",
            leader1_name: "孟美儀女士",
            leader2_title: "義生洋行的行政總裁",
            leader2_name: "陳毅正先生",
            our_services_title: '我們的服務',
            our_services_content: `          
                <p>
                    義生洋行不僅是意大利貨品進口商的領導者之一， 其亦擁有自己的<span style="color: #E1CB8B;">物流團隊</span>、<span style="color: #E1CB8B;">包裝設備</span>、
                    <span style="color: #E1CB8B;">冷藏貨倉</span>以及<span style="color: #E1CB8B;">一隊凍櫃貨車團隊</span>。
                </p>
                <p>
                    更重要的是義生洋行擁有<span style="color: #E1CB8B;">香港特區政府發出的食物製造廠牌照</span>。
                </p>
                <p>
                    憑上述牌照， 義生洋行可為顧客<span style="color: #E1CB8B;">提供包裝、切割以及食品加工等</span>服務。
                </p>
            `,
            our_logos_title: '我們的商標',
        },
        products_page: {
            title: '產品',
            partners: '我們的夥伴',
            slogan1: "香港意大利食品進口商的市場領導者之一",
            slogan2: "竭盡所能為客戶提供優質食品及酒類",
            slogan3: "義生洋行已經引入了超過70個意大利品牌",
        },
        product_info_page: {
            title: `{product_category}`,
            partners: '我們的夥伴',
            back: '上一頁',
            next: '下一頁'
        },
        affiliate:{
            telephone: `電話 {telephone}`,
            email: `{email}`,
            event_photos: `活動<br>照片`,
            recipes: `視頻<br>食譜`,
        },
        affiliate_gallery_page: {
            title: `活動照片`,
            about_affiliate: `關於<br>{affiliate_name}`,
        },
        affiliate_recipe_page: {
            title: `視頻`,
            about_affiliate: `關於<br>{affiliate_name}`,
            next_video: `下一段<br>視頻`,
            prev_video: `上一段<br>視頻`,
        },
        kitchen_page: {
            video_title: `短片`,
            recipe_title: `食譜`,
            next_video: `下一段<br>短片`,
            prev_video: `上一段<br>短片`,
        },
        affiliate_news_page: {
            title: `{affiliate_name}的信息`,
            read_more: "了解更多",
            featured_on: "刊登於",
        },
        contact_page: {
            company_name: `義生洋行`,
            address_title: `地址`,
            tel_title: `電話`,
            fax_title: `傳真`,
            email_title: `電郵`,
            contact_us: `聯繫我們`,
            form_name: `姓名`,
            form_email: `電郵`,
            form_subject: `主題`,
            form_message: `留言給我們`,
            form_submit_button: `發送`,
            form_submit_message: `謝謝您的留言！`,
        },
        footer: {
            address: `香港中環德輔道中 141 號中保集團大廈 6 樓 B、C 及 D1 室`,
            tel: `電話: (852) 2557 6123`,
            fax: `傳真: (852) 2557 5621`,
            email: `電郵: <a class="links" href="mailto:info@lorencegroup.com">info@lorencegroup.com</a>`,
            credit: `版權所有@2026 Lorence Holdings Limited 附屬公司`,
        }
    },
    }
    export default messages;